var _defs, _g;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgContrast = function SvgContrast(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-contrast"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 33
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "contrast",
    clipPath: "url(#clip-contrast)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon_ionic-ios-contrast",
    "data-name": "Icon ionic-ios-contrast",
    d: "M15.5,3.375A12.127,12.127,0,1,0,27.63,15.5,12.126,12.126,0,0,0,15.5,3.375Zm7.422,19.55A10.425,10.425,0,0,1,15.5,26V5.008a10.5,10.5,0,0,1,7.422,17.917Z",
    transform: "translate(0.625 0.625)"
  }))));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgContrast, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/contrast.0fb042eb.svg";
export { ForwardRef as ReactComponent };